import { db } from "./firebaseConfig";
import { collection, addDoc } from "firebase/firestore";

const useFirestoreWriter = (collectionName) => {
  const addDocument = async (document) => {
    try {
      const docRef = await addDoc(collection(db, collectionName), document);
      console.log(
        `[firestore] wrote doc id=${docRef.id} to collection="${collectionName}"`
      );
      return docRef;
    } catch (e) {
      console.error(
        `[firestore] FAILED writing to collection="${collectionName}":`,
        e
      );
      throw e;
    }
  };

  return { addDocument };
};

export { useFirestoreWriter };
